const SagaStatus = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
};

export default SagaStatus;
